/** The three plans, as shown on the landing page and in Billing. Keep in step with PLANS in backend/server.py. */
export const PLANS = [
  {
    id: "payg",
    name: "Pay as you go",
    price: "£12",
    unit: "per screening",
    note: "No monthly fee",
    fits: "1–2 properties a month",
    features: [
      { text: "Pay only for the screenings you use", included: true },
      { text: "Document and fraud checks on every application", included: true },
      { text: "Unused screenings roll over", included: false },
      { text: "CRM integration and API", included: false },
    ],
  },
  {
    id: "starter",
    name: "Starter",
    price: "£199",
    unit: "/ month",
    note: "£3.98 per screening if fully used",
    fits: "5–7 properties a month",
    features: [
      { text: "Unused screenings roll over for 1 month", included: true },
      { text: "Document and fraud checks on every application", included: true },
      { text: "CRM integration and API", included: false },
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: "£449",
    unit: "/ month",
    note: "£3.45 per screening if fully used",
    fits: "13–18 properties a month",
    features: [
      { text: "Unused screenings roll over for 1 month", included: true },
      { text: "Document and fraud checks on every application", included: true },
      { text: "CRM integration and API", included: true },
    ],
  },
];
export const PLAN_ORDER = PLANS.map((p) => p.id);
export const planById = (id) => PLANS.find((p) => p.id === id) || PLANS[0];
